import { RandomDataGenerator } from 'framework/RandomDataGenerator/RandomDataGenerator';
import { Bubble, BubbleType, BubbleColor } from './types';
import { Place } from 'js/bubbleCore/types';

export const regularColors = [
  BubbleColor.A,
  BubbleColor.B,
  BubbleColor.C,
  BubbleColor.D,
  BubbleColor.E,
  BubbleColor.F,
];

export class BubbleFactory {
  private readonly rnd: RandomDataGenerator;

  constructor(rnd: RandomDataGenerator) {
    this.rnd = rnd;
  }

  public createRegular(col: number, row: number, colors?: BubbleColor[]): Bubble<BubbleType.Regular> {
    const properColor = this.rnd.pick(Object.values(colors || regularColors)) as BubbleColor;

    return {
      id: this.rnd.uuid(),
      core: {
        type: BubbleType.Regular,
        color: properColor,
      },
      col,
      row,
      place: Place.Grid,
      radius: 0.3,
      radiusInGrid: 0.8,
      hexSpaceX: 0,
      hexSpaceY: 0,
      velX: 0,
      velY: 0,
    };
  }

  public createFire(col: number, row: number): Bubble<BubbleType.Fire> {
    return {
      id: this.rnd.uuid(),
      core: {
        type: BubbleType.Fire,
        color: BubbleColor.NONE,
      },
      col,
      row,
      place: Place.Grid,
      radius: 0.8,
      radiusInGrid: 0.8,
      hexSpaceX: 0,
      hexSpaceY: 0,
      velX: 0,
      velY: 0,
    }; 
  }
}